import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { Collapse } from 'reactstrap';

const Sidebar = ({ isOpen, toggle }) => {
  const navigate = useNavigate();
  const [isToolsOpen, setIsToolsOpen] = useState(false);
  const [isNovetatsOpen, setIsNovetatsOpen] = useState(false);
  const toggleTools = () => setIsToolsOpen(!isToolsOpen);

  const sidebarClass = isOpen ? "sidebar-expanded" : "sidebar-collapsed";

  return (
    <div className={`vertical-menu ${sidebarClass}`}>
      <div className="navbar-brand-box">
        <NavLink to="/" className="logo-link text-decoration-none">
            <span className="logo-lg">
               SERIES<span className="fw-light">DASH</span>
            </span>
            <span className="logo-sm">
               <i className="bi bi-play-circle-fill"></i>
            </span>
        </NavLink>
      </div>

      <div data-simplebar className="h-100">
        <div id="sidebar-menu">
            <ul className="list-unstyled" id="side-menu">
                <li className="menu-title">
                    <span className="title-full">Menú Principal</span>
                    <span className="title-short">...</span>
                </li>
                
                <li>
                    <NavLink to="/" className={({ isActive }) => isActive ? "active-link waves-effect" : "waves-effect"}>
                        <i className="bi bi-grid-fill"></i>
                        <span className="menu-item-text">Dashboard</span>
                    </NavLink>
                </li>
                
                <li>
                    <div onClick={() => setIsNovetatsOpen(!isNovetatsOpen)} className={`has-arrow waves-effect ${isNovetatsOpen ? 'mm-active' : ''}`}>
                         <i className="bi bi-stars"></i>
                        <span className="menu-item-text">Novetats</span>
                        <i className={`bi bi-chevron-${isNovetatsOpen ? 'down' : 'right'} arrow-icon`}></i>
                    </div>
                    <Collapse isOpen={isNovetatsOpen || !isOpen}>
                        <ul className="sub-menu list-unstyled">
                            <li>
                                <NavLink to="/premieres" end className={({ isActive }) => isActive ? "active-link" : ""}>
                                    <i className="bi bi-tv sub-icon"></i>
                                    <span className="sub-item-text">Sèries</span>
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="/premieres/movies" className={({ isActive }) => isActive ? "active-link" : ""}>
                                    <i className="bi bi-film sub-icon"></i>
                                    <span className="sub-item-text">Pel·lícules</span>
                                </NavLink>
                            </li>
                        </ul>
                    </Collapse>
                </li>

                <li className="menu-title mt-4">
                    <span className="title-full">Enllaços Ràpids</span>
                    <span className="title-short">...</span>
                </li>
                
                <li>
                    <NavLink to="/links" className={({ isActive }) => isActive ? "active-link waves-effect" : "waves-effect"}>
                        <i className="bi bi-collection-play"></i>
                        <span className="menu-item-text">Tots els Enllaços</span>
                    </NavLink>
                </li>

                <li>
                    <div onClick={toggleTools} className={`has-arrow waves-effect ${isToolsOpen ? 'mm-active' : ''}`}>
                        <i className="bi bi-lightning-fill"></i>
                        <span className="menu-item-text">Accessos Directes</span>
                        <i className={`bi bi-chevron-${isToolsOpen ? 'down' : 'right'} arrow-icon`}></i>
                    </div>
                    <Collapse isOpen={isToolsOpen || !isOpen}> 
                        <ul className="sub-menu list-unstyled">
                             <li><a href="https://btdig.com/search?order=2&q=xvid+castellano" target="_blank" rel="noreferrer"><i className="bi bi-search sub-icon"></i><span className="sub-item-text">BTDigg</span></a></li>
                             <li><a href="https://wolfmax4k.com/" target="_blank" rel="noreferrer"><i className="bi bi-globe sub-icon"></i><span className="sub-item-text">Wolfmax4k</span></a></li>
                             <li><a href="https://www.filmaffinity.com/es/main.html" target="_blank" rel="noreferrer"><i className="bi bi-star sub-icon"></i><span className="sub-item-text">FilmAffinity</span></a></li>
                             <li><a href="https://www.opensubtitles.org/es" target="_blank" rel="noreferrer"><i className="bi bi-chat-left-text sub-icon"></i><span className="sub-item-text">OpenSubtitles</span></a></li>
                             <li><a href="https://www.justwatch.com/es" target="_blank" rel="noreferrer"><i className="bi bi-play-btn sub-icon"></i><span className="sub-item-text">JustWatch</span></a></li>
                             <li><a href="https://elpais.com/especiales/calendario-series/" target="_blank" rel="noreferrer"><i className="bi bi-calendar-event sub-icon"></i><span className="sub-item-text">Calendari</span></a></li>
                        </ul>
                    </Collapse>
                </li>
            </ul>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
